import React from 'react';

const AccellorLoading = ({ size = 100 }) => {
  return (
    <div className="flex items-center justify-center w-full h-64">
      <svg width={size} height={size} viewBox="0 0 48 45" xmlns="http://www.w3.org/2000/svg">
        <defs>
          {/* Water effect filters */}
          <filter id="turbulence1">
            <feTurbulence 
              type="turbulence" 
              baseFrequency="0.02 0.05" 
              numOctaves="3" 
              seed="1"
              result="turb1">
              <animate 
                attributeName="baseFrequency" 
                values="0.02 0.05;0.04 0.08;0.02 0.05" 
                dur="3s" 
                repeatCount="indefinite" 
              />
            </feTurbulence>
            <feDisplacementMap in="SourceGraphic" in2="turb1" scale="3"/>
          </filter>

          <filter id="turbulence2">
            <feTurbulence 
              type="fractalNoise" 
              baseFrequency="0.01 0.03" 
              numOctaves="2" 
              seed="2"
              result="turb2">
              <animate 
                attributeName="baseFrequency" 
                values="0.01 0.03;0.02 0.05;0.01 0.03" 
                dur="2.5s" 
                repeatCount="indefinite" 
              />
            </feTurbulence>
            <feDisplacementMap in="SourceGraphic" in2="turb2" scale="2"/>
          </filter>

          {/* Water gradients */}
          <linearGradient id="waterGradient1" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="0" y2="45">
            <stop offset="0%" stopColor="#08adc2" stopOpacity="0.8"/>
            <stop offset="50%" stopColor="#4ec8f0" stopOpacity="0.6"/>
            <stop offset="100%" stopColor="#08adc2" stopOpacity="0.8"/>
          </linearGradient>

          <linearGradient id="waterGradient2" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="0" y2="45">
            <stop offset="0%" stopColor="#4ec8f0" stopOpacity="0.4"/>
            <stop offset="50%" stopColor="#08adc2" stopOpacity="0.6"/>
            <stop offset="100%" stopColor="#4ec8f0" stopOpacity="0.4"/>
          </linearGradient>

          <linearGradient id="waterGradient3" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="0" y2="45">
            <stop offset="0%" stopColor="#08adc2" stopOpacity="0.3"/>
            <stop offset="50%" stopColor="#4ec8f0" stopOpacity="0.5"/>
            <stop offset="100%" stopColor="#08adc2" stopOpacity="0.3"/>
          </linearGradient>

          {/* Clip path for the logo shape */}
          <clipPath id="logoShape">
            <path d="m9.72658 12.5435-9.230681 18.4386c-.957646 1.9156-.4823802 4.2574 1.030571 5.7732l4.27597 4.3503 12.38006-25.1495s-4.3532-4.2582-8.45557-3.4123z" />
            <path d="m48.0278 39.8007c-.0452-.0968 3.9561-12.871-23.441-9.283 0 0-11.0101 1.5933-19.57766 9.7803l3.81813 3.885c1.63673 1.6581 4.20443 1.9601 6.18063.7264 7.6754-4.7925 25.2538-16.355 33.0195-5.1087z" />
            <path d="m48.2003 37.6808c-9.6675 10.8418-10.7216-6.8551-18.8833-19.0661-5.1414-7.6921-11.5789-8.1023-15.6392-7.3524l.0555.0213c12.0698 4.642 15.2362 15.7304 18.5253 24.8309 1.9811 5.4812 6.1184 8.3861 10.1318 9.2662.6756-.1693 1.3041-.4101 1.8662-.7186 4.5577-2.4994 3.9441-6.9813 3.9441-6.9813z" />
          </clipPath>

          {/* Fill animation mask */}
          <mask id="fillMask">
            <rect x="-48" y="-45" width="96" height="90" fill="white">
              <animateTransform
                attributeName="transform"
                type="translate"
                values="0,0; 48,45"
                dur="3s"
                repeatCount="1"
                fill="freeze"
              />
            </rect>
          </mask>
        </defs>

        {/* Unfilled logo outline */}
        <g opacity="0.3">
          <path d="m9.72658 12.5435-9.230681 18.4386c-.957646 1.9156-.4823802 4.2574 1.030571 5.7732l4.27597 4.3503 12.38006-25.1495s-4.3532-4.2582-8.45557-3.4123z" fill="#53647c"/>
          <path d="m48.0278 39.8007c-.0452-.0968 3.9561-12.871-23.441-9.283 0 0-11.0101 1.5933-19.57766 9.7803l3.81813 3.885c1.63673 1.6581 4.20443 1.9601 6.18063.7264 7.6754-4.7925 25.2538-16.355 33.0195-5.1087z" fill="#53647c"/>
          <path d="m48.2003 37.6808c-9.6675 10.8418-10.7216-6.8551-18.8833-19.0661-5.1414-7.6921-11.5789-8.1023-15.6392-7.3524l.0555.0213c12.0698 4.642 15.2362 15.7304 18.5253 24.8309 1.9811 5.4812 6.1184 8.3861 10.1318 9.2662.6756-.1693 1.3041-.4101 1.8662-.7186 4.5577-2.4994 3.9441-6.9813 3.9441-6.9813z" fill="#53647c"/>
        </g>

        {/* Filled logo with water animation */}
        <g clipPath="url(#logoShape)" mask="url(#fillMask)">
          {/* Base water layer */}
          <g filter="url(#turbulence1)">
            <rect x="0" y="0" width="48" height="45" fill="url(#waterGradient1)">
              <animate
                attributeName="y"
                values="-45;0"
                dur="3s"
                repeatCount="indefinite"
              />
            </rect>
          </g>

          {/* Second water layer with different motion */}
          <g filter="url(#turbulence2)">
            <rect x="0" y="0" width="48" height="45" fill="url(#waterGradient2)">
              <animate
                attributeName="y"
                values="0;-45"
                dur="2.5s"
                repeatCount="indefinite"
              />
            </rect>
          </g>

          {/* Third water layer for additional depth */}
          <rect x="0" y="0" width="48" height="45" fill="url(#waterGradient3)">
            <animate
              attributeName="y"
              values="-22.5;22.5;-22.5"
              dur="4s"
              repeatCount="indefinite"
            />
          </rect>

          {/* Ripple effects */}
          <circle cx="24" cy="22.5" r="1" fill="white" opacity="0.3">
            <animate
              attributeName="r"
              values="1;5;1"
              dur="2s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="opacity"
              values="0.3;0;0.3"
              dur="2s"
              repeatCount="indefinite"
            />
          </circle>

          <circle cx="12" cy="30" r="1" fill="white" opacity="0.3">
            <animate
              attributeName="r"
              values="1;4;1"
              dur="2.5s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="opacity"
              values="0.3;0;0.3"
              dur="2.5s"
              repeatCount="indefinite"
            />
          </circle>

          <circle cx="36" cy="15" r="1" fill="white" opacity="0.3">
            <animate
              attributeName="r"
              values="1;3;1"
              dur="1.5s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="opacity"
              values="0.3;0;0.3"
              dur="1.5s"
              repeatCount="indefinite"
            />
          </circle>

          {/* Bubble effects */}
          <circle cx="20" cy="45" r="1" fill="white" opacity="0.4">
            <animate
              attributeName="cy"
              values="45;0;45"
              dur="4s"
              repeatCount="indefinite"
            />
          </circle>

          <circle cx="30" cy="45" r="0.8" fill="white" opacity="0.4">
            <animate
              attributeName="cy"
              values="45;10;45"
              dur="3s"
              repeatCount="indefinite"
            />
          </circle>

          <circle cx="15" cy="45" r="0.6" fill="white" opacity="0.4">
            <animate
              attributeName="cy"
              values="45;5;45"
              dur="3.5s"
              repeatCount="indefinite"
            />
          </circle>
        </g>
      </svg>
    </div>
  );
};

export default AccellorLoading; 